<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Text, Token, Stack } from '@Shelly/shelly-design-system';
	import {
		capFirstChar,
		conditionsFunc,
		makeValueAndUnitsPrimaryAndBold,
	} from 'src/helpers/utilities';
	import type { IAlarmZone } from '../../alarm_object';
	import CustomDynamicInput from 'src/components/CustomDynamicInput.svelte';

	export let alarm_object: IAlarmZone,
		delayActionError: string | undefined = '';

	alarm_object.do[0].wait =
		alarm_object.do[0]?.scale === 'min' ? +alarm_object.do[0].wait / 60 : alarm_object.do[0].wait;

	$: {
		delayActionError = conditionsFunc(String(alarm_object.do[0].wait))
			? $format('value_must_be_equal_or_greater_than_zero', {
					default: 'Value must be an integer and equal or greater than 0.',
				})
			: undefined;
	}

	function handleDelayValue(value) {
		if (conditionsFunc(value)) {
			delayActionError = $format('value_must_be_equal_or_greater_than_zero', {
				default: 'Value must be an integer and equal or greater than 0.',
			});
		} else {
			delayActionError = '';
		}
		alarm_object.do[0].wait = value;
	}
</script>

<Text element="h2" class="mb-s">{$format('delay_alarming', { default: 'Delay alarming' })}</Text>
<Text styleType="body-small" class="mb-s">
	{@html makeValueAndUnitsPrimaryAndBold(
		`${$format('action_delay', {
			values: {
				value_and_units: $format(
					`delay_units_${alarm_object.do[0]?.scale === 'min' ? 'minutes' : 'seconds'}`,
					{
						values: { n: delayActionError ? 0 : alarm_object.do[0].wait },
					},
				),
			},
		})}`,
	)}
</Text>

<div class="d-flex flex-wrap flex-direction-sm-row flex-direction-md-column">
	<CustomDynamicInput
		additionalContainerClass="d-flex width-md-auto width-sm-full"
		minusFunction={() => handleDelayValue(delayActionError ? 0 : +alarm_object.do[0].wait - 1)}
		plusFunction={() => handleDelayValue(delayActionError ? 0 : +alarm_object.do[0].wait + 1)}
		disabledMinusBtn={+alarm_object.do[0].wait <= 0}
		additionalInputAttributes={{
			min: '0',
			max: '1440',
			icon: 'fas fa-clock',
		}}
		bind:error={delayActionError}
		bind:value={alarm_object.do[0].wait}
		inputHandler={(e) => handleDelayValue(e.target.value)}
	/>

	<Stack class="ml-sm-0 ml-md-s mt-md-0 mt-sm-s align-self-start" gap="s" direction="column">
		<Token
			id="token-woexf6d"
			size="m"
			title={capFirstChar($format('select_units_seconds'))}
			selected={!alarm_object.do[0]?.scale || alarm_object.do[0]?.scale === 'sec'}
			on:click={() => {
				alarm_object.do[0].scale = 'sec';
			}}
		/>

		<Token
			id="token-tr0lh7o"
			size="m"
			title={capFirstChar($format('select_units_minutes'))}
			selected={alarm_object.do[0]?.scale === 'min'}
			on:click={() => {
				alarm_object.do[0].scale = 'min';
			}}
		/>
	</Stack>
</div>
